module.exports = __webpack_public_path__ + "img/ux-d.21490b36.svg";